var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestfive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.777,
    height: 80.058,
    viewBox: "0 0 80.777 80.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Client_rating_x2C__testimonial_x2C__customers_x2C__star_team_x2C__team_x2C__group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_720_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_852_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_739_",
    transform: "translate(7.978 6.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15031",
    "data-name": "Group 15031"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5383",
    "data-name": "Path 5383",
    d: "M15.967,27.18a1.33,1.33,0,0,1-1.33-1.33V21.035a1.321,1.321,0,0,1,.527-1.058A5.279,5.279,0,0,0,17.3,15.746V11.757a5.318,5.318,0,1,0-10.637,0v3.989a5.279,5.279,0,0,0,2.133,4.231,1.326,1.326,0,0,1,.527,1.061v4.816a1.33,1.33,0,1,1-2.659,0V21.662A7.888,7.888,0,0,1,4,15.746V11.757a7.978,7.978,0,1,1,15.955,0v3.989A7.892,7.892,0,0,1,17.3,21.662v4.188a1.33,1.33,0,0,1-1.33,1.33Z",
    transform: "translate(-4 -3.779)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_737_",
    transform: "translate(15.966 17.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15032",
    "data-name": "Group 15032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5384",
    "data-name": "Path 5384",
    d: "M8.331,16.953a1.328,1.328,0,0,1-.263-2.63,5.344,5.344,0,0,0,4.244-5.215,1.33,1.33,0,0,1,2.659,0A8.007,8.007,0,0,1,8.6,16.924a1.318,1.318,0,0,1-.269.029Z",
    transform: "translate(-7.004 -7.779)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_735_",
    transform: "translate(18.615 27.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15033",
    "data-name": "Group 15033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5385",
    "data-name": "Path 5385",
    d: "M14.313,16.359a1.3,1.3,0,0,1-.524-.109L8.805,14.109a1.329,1.329,0,0,1,1.048-2.444l4.983,2.141a1.331,1.331,0,0,1-.524,2.553Z",
    transform: "translate(-8 -11.558)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_721_",
    transform: "translate(0 27.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15034",
    "data-name": "Group 15034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5386",
    "data-name": "Path 5386",
    d: "M8.978,32.47a1.31,1.31,0,0,1-.55-.12l-5.09-2.314A4,4,0,0,1,1,26.4V22.719a9.261,9.261,0,0,1,5.622-8.536l5.816-2.524A1.329,1.329,0,1,1,13.5,14.1L7.675,16.624a6.616,6.616,0,0,0-4.015,6.095V26.4a1.337,1.337,0,0,0,.779,1.213l5.09,2.314a1.33,1.33,0,0,1-.55,2.54Z",
    transform: "translate(-1 -11.548)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5197_",
    transform: "translate(7.978 6.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15035",
    "data-name": "Group 15035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5387",
    "data-name": "Path 5387",
    d: "M17.134,14.177a11.575,11.575,0,0,1-7.321-2.638A1.328,1.328,0,1,1,11.48,9.472a8.781,8.781,0,0,0,5.81,2.045,5.319,5.319,0,0,0-10.632.239v.984a1.33,1.33,0,0,1-2.659,0v-.984a7.978,7.978,0,1,1,15.955,0v.931A1.331,1.331,0,0,1,18.836,14a10.629,10.629,0,0,1-1.7.176Z",
    transform: "translate(-4 -3.779)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5195_",
    transform: "translate(55.844 6.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15036",
    "data-name": "Group 15036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5388",
    "data-name": "Path 5388",
    d: "M33.967,27.179a1.33,1.33,0,0,1-1.33-1.33V21.033a1.321,1.321,0,0,1,.527-1.058A5.279,5.279,0,0,0,35.3,15.744V11.755a5.318,5.318,0,1,0-10.637,0v3.989a5.279,5.279,0,0,0,2.133,4.231,1.326,1.326,0,0,1,.527,1.061v4.816a1.33,1.33,0,1,1-2.659,0V21.663A7.888,7.888,0,0,1,22,15.747V11.758a7.978,7.978,0,0,1,15.955,0v3.989A7.892,7.892,0,0,1,35.3,21.663v4.188A1.33,1.33,0,0,1,33.967,27.179Z",
    transform: "translate(-22 -3.78)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5194_",
    transform: "translate(63.832 17.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15037",
    "data-name": "Group 15037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5389",
    "data-name": "Path 5389",
    d: "M26.331,16.953a1.328,1.328,0,0,1-.263-2.63,5.344,5.344,0,0,0,4.244-5.215,1.33,1.33,0,0,1,2.659,0A8.007,8.007,0,0,1,26.6,16.924,1.318,1.318,0,0,1,26.331,16.953Z",
    transform: "translate(-25.004 -7.779)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_730_",
    transform: "translate(53.911 27.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15038",
    "data-name": "Group 15038"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5390",
    "data-name": "Path 5390",
    d: "M22.6,16.191a1.331,1.331,0,0,1-.524-2.553l4.593-1.973a1.329,1.329,0,0,1,1.048,2.444l-4.593,1.973A1.3,1.3,0,0,1,22.6,16.191Z",
    transform: "translate(-21.273 -11.558)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_715_",
    transform: "translate(66.481 27.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15039",
    "data-name": "Group 15039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5391",
    "data-name": "Path 5391",
    d: "M31.318,32.471a1.33,1.33,0,0,1-.55-2.54l5.09-2.314a1.335,1.335,0,0,0,.779-1.213V22.72a6.609,6.609,0,0,0-4.007-6.09L26.8,14.1a1.329,1.329,0,1,1,1.058-2.439l5.821,2.526A9.258,9.258,0,0,1,39.3,22.72v3.686a4,4,0,0,1-2.337,3.633l-5.09,2.314a1.352,1.352,0,0,1-.55.12Z",
    transform: "translate(-26 -11.548)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_724_",
    transform: "translate(33.043 7.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15040",
    "data-name": "Group 15040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5392",
    "data-name": "Path 5392",
    d: "M23.755,9.69c-3.781,0-7.717-1.332-9.887-3.284A1.328,1.328,0,1,1,15.644,4.43c2.622,2.356,8.9,3.587,12.5,1.657A1.33,1.33,0,1,1,29.4,8.43a12.072,12.072,0,0,1-5.648,1.26Z",
    transform: "translate(-13.426 -4.089)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_710_",
    transform: "translate(13.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_712_",
    transform: "translate(19.193 30.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15041",
    "data-name": "Group 15041"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5393",
    "data-name": "Path 5393",
    d: "M20.6,19.689a7.828,7.828,0,0,1-7.313-5.263,1.329,1.329,0,0,1,2.521-.84A5.2,5.2,0,0,0,20.6,17.027,5.43,5.43,0,0,0,25.5,13.5a1.33,1.33,0,0,1,2.508.886C27.935,14.6,26.1,19.689,20.6,19.689Z",
    transform: "translate(-13.218 -12.621)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_726_",
    transform: "translate(30.581 24.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15042",
    "data-name": "Group 15042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5394",
    "data-name": "Path 5394",
    d: "M38.774,33.713a1.33,1.33,0,0,1-1.33-1.33v-.742a9.3,9.3,0,0,0-6.185-8.77L20.167,18.935A3.98,3.98,0,0,1,17.5,15.18V11.91a1.33,1.33,0,1,1,2.659,0V15.18a1.325,1.325,0,0,0,.891,1.245l11.094,3.938A11.956,11.956,0,0,1,40.1,31.641v.745a1.328,1.328,0,0,1-1.33,1.327Z",
    transform: "translate(-17.5 -10.58)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_725_",
    transform: "translate(0 24.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15043",
    "data-name": "Group 15043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5395",
    "data-name": "Path 5395",
    d: "M7.33,33.714A1.33,1.33,0,0,1,6,32.385v-.718a12,12,0,0,1,7.983-11.3L25.051,16.48a1.327,1.327,0,0,0,.894-1.247V11.909a1.33,1.33,0,1,1,2.659,0v3.324a3.989,3.989,0,0,1-2.673,3.758l-11.06,3.88a9.332,9.332,0,0,0-6.212,8.8v.718A1.328,1.328,0,0,1,7.33,33.714Z",
    transform: "translate(-6 -10.579)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_706_",
    transform: "translate(15.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15044",
    "data-name": "Group 15044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5396",
    "data-name": "Path 5396",
    d: "M22.637,30.531a1.33,1.33,0,1,1,0-2.659c2.76,0,7.978-2.5,7.978-11.967V11.916a7.978,7.978,0,0,0-15.955,0V15.9c0,4.585,1.226,8.092,3.542,10.142a1.329,1.329,0,0,1-1.76,1.992C14.415,26.247,12,22.689,12,15.9V11.916a10.637,10.637,0,0,1,21.274,0V15.9C33.274,27.475,26.317,30.531,22.637,30.531Z",
    transform: "translate(-12 -1.279)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1069_",
    transform: "translate(1.301 48.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_908_",
    transform: "translate(53.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15045",
    "data-name": "Group 15045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5397",
    "data-name": "Path 5397",
    d: "M26.979,42.562a1.329,1.329,0,0,1-.588-2.521l6.576-3.258a1.329,1.329,0,0,1,1.178,0l4.3,2.13-.7-4.744a1.328,1.328,0,0,1,.367-1.122l3.359-3.433-4.733-.806a1.337,1.337,0,0,1-.955-.694l-2.223-4.249-2.226,4.249a1.337,1.337,0,0,1-.955.694l-4.731.806L29,33.047a1.33,1.33,0,0,1-1.9,1.859l-5.13-5.247A1.328,1.328,0,0,1,22.7,27.42L29.285,26.3l3.1-5.914a1.33,1.33,0,0,1,2.356,0l3.1,5.914,6.587,1.122a1.328,1.328,0,0,1,.729,2.239l-4.672,4.773.973,6.606a1.337,1.337,0,0,1-.535,1.268,1.318,1.318,0,0,1-1.372.114l-5.983-2.965-5.986,2.965a1.306,1.306,0,0,1-.6.141Z",
    transform: "translate(-21.592 -19.671)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1071_",
    transform: "translate(24.675 3.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15046",
    "data-name": "Group 15046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5398",
    "data-name": "Path 5398",
    d: "M16.905,47.557a1.328,1.328,0,0,1-1.316-1.524L16.753,38.1l-5.606-5.733a1.328,1.328,0,0,1,.729-2.239l7.909-1.346,3.718-7.1a1.386,1.386,0,0,1,2.359,0l3.718,7.1,7.909,1.346a1.328,1.328,0,0,1,.729,2.239L32.608,38.1l1.167,7.933a1.337,1.337,0,0,1-.535,1.268,1.318,1.318,0,0,1-1.372.114l-7.188-3.561L17.5,47.416A1.321,1.321,0,0,1,16.905,47.557ZM14.823,32.322l4.292,4.39a1.339,1.339,0,0,1,.367,1.122l-.894,6.071,5.5-2.726a1.312,1.312,0,0,1,1.178,0l5.5,2.726-.894-6.071a1.328,1.328,0,0,1,.367-1.122l4.295-4.39L28.481,31.29a1.337,1.337,0,0,1-.955-.694l-2.845-5.438L21.835,30.6a1.337,1.337,0,0,1-.955.694Z",
    transform: "translate(-10.768 -21.021)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_760_",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15047",
    "data-name": "Group 15047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5399",
    "data-name": "Path 5399",
    d: "M20.034,42.56a1.343,1.343,0,0,1-.59-.138L13.46,39.457,7.474,42.424a1.331,1.331,0,0,1-1.907-1.385l.973-6.606L1.869,29.66A1.328,1.328,0,0,1,2.6,27.421L9.184,26.3l3.1-5.914a1.33,1.33,0,0,1,2.356,0l3.1,5.914,6.584,1.122a1.328,1.328,0,0,1,.729,2.239L19.917,34.9a1.33,1.33,0,0,1-1.9-1.859l3.356-3.433-4.731-.806a1.332,1.332,0,0,1-.955-.694l-2.223-4.249-2.226,4.249a1.337,1.337,0,0,1-.955.694l-4.733.806,3.359,3.433a1.339,1.339,0,0,1,.367,1.122l-.7,4.744,4.3-2.13a1.329,1.329,0,0,1,1.178,0l6.574,3.258a1.331,1.331,0,0,1,.6,1.782,1.347,1.347,0,0,1-1.2.739Z",
    transform: "translate(-1.489 -19.672)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestfive);
export default __webpack_public_path__ + "static/media/testfive.b2e683193b7c90f111a7d3390baf2986.svg";
export { ForwardRef as ReactComponent };